import {Router, Route, Switch} from 'react-router-dom'
import {createBrowserHistory} from 'history'
import React from 'react'

import PrivateRoute from './PrivateRoute'
import PublicRoute from './PublicRoute'
import MainPage from '../components/MainPage'

export const history = createBrowserHistory();

class AppRouter extends React.Component {
    render() {
        return (
            <Router history={history}>
                <div>
                    <Switch>
                        <Route path="/" component={PublicRoute(MainPage)} exact={true} />
                    </Switch>
                </div>
            </Router>
        )
    }
}
export default AppRouter;